import { useRef, useEffect, useCallback } from 'react';

export function useAutoSave(saveFn, delay = 2000) {
  const timerRef = useRef(null);
  const saveFnRef = useRef(saveFn);
  const pendingRef = useRef(false);

  useEffect(() => { saveFnRef.current = saveFn; }, [saveFn]);

  const trigger = useCallback(() => {
    pendingRef.current = true;
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(async () => {
      if (pendingRef.current) {
        await saveFnRef.current();
        pendingRef.current = false;
      }
    }, delay);
  }, [delay]);

  const flush = useCallback(async () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    if (pendingRef.current) {
      await saveFnRef.current();
      pendingRef.current = false;
    }
  }, []);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return { trigger, flush, isPending: () => pendingRef.current };
}
